import Url, {qs} from 'url-parse';
import {getEnv} from '../../../common/env/env';
import {KakaoentPolicyType} from '../type';

export function getKakaoentPolicyUrl({type}: {type: KakaoentPolicyType}): {
  /**
   * 웹에서 새탭으로 띄울 때 사용하는 URL. 탭(영상정보) 미노출
   */
  urlExcludeVod: () => Url<string>;
  /**
   * 웹에서 새탭으로 띄울 때 사용하는 URL. 탭(영상정보) 미노출
   */
  onlyContentUrl: () => Url<string>;
  /**
   * 새로운 웹뷰 띄우는 스킴. 탭(영상정보) 미노출 & 상/하단 헤더, 푸터 제거
   */
  webInAppScheme: () => string;
  /**
   * 외부 브라우저로 띄우는 스킴. 탭(영상정보) 미노출
   */
  externalBrowserScheme: () => string;
} {
  return {
    urlExcludeVod: getUrlExcludeVod,
    onlyContentUrl: getOnlyContentUrl,
    webInAppScheme: () =>
      `kakaopage://open/webinapp?url=${encodeURIComponent(
        getOnlyContentUrl().href
      )}`,
    externalBrowserScheme: () =>
      `kakaopage://open/browser?url=${encodeURIComponent(
        getUrlExcludeVod().href
      )}`,
  };

  function getUrlExcludeVod(): Url<string> {
    const parsed = Url(getUrl());
    parsed.set('query', {
      ...qs.parse(parsed.query),
      ...{isTabMode: true, isHeaderMode: false, isFooterMode: false},
    });
    return parsed;
  }

  function getOnlyContentUrl(): Url<string> {
    const parsed = Url(getUrl());
    parsed.set('query', {
      ...qs.parse(parsed.query),
      ...{isTabMode: true, isHeaderMode: true, isFooterMode: true},
    });
    return parsed;
  }

  function getUrl(): string {
    switch (type) {
      case KakaoentPolicyType.Policy:
        return getEnv()?.policyPrivacyUrl;
      case KakaoentPolicyType.TargetAd:
        return getEnv()?.policyTargetAdUrl;
    }
  }
}
